const GroupVisualizations = {
  STANDARD: "",
  SUBTOTAL_GROUP: "subtotalGroup"
};

GroupVisualizations.ALL = Object.values(GroupVisualizations);

export default GroupVisualizations;
